<template>
  <main>
    <div class="row">
      <div class="col-md-12">
        <TopTemplate>
          <template #left-element>
            <h3>{{ $t("title.addMsg") }}</h3>
          </template>

          <template #right-element>
            <router-link :to="{name: 'Message', params: {notice_status: 'send'}}" class="btn btn-outline-primary button" :disabled="loading">
              <i class="arrow left" />
              {{ $t("button.retour") }}
            </router-link>
          </template>
        </TopTemplate>
        <div v-if="is_created" class="alert alert-success" role="alert">
          {{ $t("common.succesMessage") }}
        </div>
        <div v-if="!is_created && errorSave" class="alert alert-danger" role="alert">
          {{ errorSave }}
        </div>
        <div v-if="!is_created && errorMessageSave" class="alert alert-danger" role="alert">
          {{ this.errorMessages }}
        </div>

        <div class="ajout-container message-add">
          <form novalidate enctype="multipart/form-data" @submit.prevent="onSubmitCreateMessage">
            <div class="row">
              <div ref="simpleselect" class="col-md-12">
                <div class="ajout-container__simple">
                  <label>{{ $t("message.formMsg.envoiA") }} <sup>*</sup></label>
                  <v-select
                    v-model="message.selectedType"
                    :options="existStudent ? options : optionsType"
                    label="name"
                    :searchable="false"
                    :reduce="(option) => option.id"
                    class="form-control"
                    :class="{'is-invalid': v$.message.selectedType.$error}"
                    @update:modelValue="ChangeType($event)"
                  >
                    <template #no-options="{}">
                      {{ $t("common.emptysearshType") }}
                    </template>
                  </v-select>
                  <span v-if="v$.message.selectedType.$error" class="invalid-feedback">
                    {{ v$.message.selectedType.$errors[0].$message }}
                  </span>
                </div>
              </div>

              <div class="col-md-6 select-wrapper">
                <div class="ajout-container__multiple">
                  <label v-if="student">{{ $t("message.formMsg.selectStudent") }} <sup>*</sup></label>
                  <label v-if="level">{{ $t("message.formMsg.selectLevel") }} <sup>*</sup></label>
                  <label v-if="classe">{{ $t("message.formMsg.selectClass") }} <sup>*</sup></label>
                  <label v-if="teacher">{{ $t("message.formMsg.selectTeacher") }} <sup>*</sup></label>
                  <v-select
                    v-if="student"
                    v-model="message.selectedStudent_ids"
                    label="item_data"
                    :searchable="true"
                    :options="students"
                    :reduce="(option) => option.id"
                    multiple
                    class="form-control"
                    :class="v$.message.selectedStudent_ids.$error ? 'is-invalid' : ''"
                    @update:modelValue="ChangeStudent($event)"
                    @input="searshStudent($event)"
                  >
                    <template #no-options="{}">
                      {{ $t("common.emptysearshStudent") }}
                    </template>
                  </v-select>
                  <div v-if="v$.message.selectedStudent_ids.$error && student" class="invalid-feedback">
                    {{ $t("validation.required") }}
                  </div>
                  <v-select
                    v-if="level"
                    v-model="message.selectedLevels_ids"
                    label="name"
                    :searchable="true"
                    :options="levels"
                    :reduce="(option) => option.id"
                    multiple
                    :class="v$.message.selectedLevels_ids.$error ? 'is-invalid' : ''"
                    @update:modelValue="ChangeLevel($event)"
                  >
                    <template #no-options="{}">
                      {{ $t("common.emptysearshLevels") }}
                    </template>
                  </v-select>
                  <div v-if="v$.message.selectedLevels_ids.$error && level" class="invalid-feedback">
                    {{ $t("validation.required") }}
                  </div>
                  <v-select
                    v-if="classe"
                    v-model="message.selectedClasses_ids"
                    label="name"
                    :searchable="true"
                    :options="classes"
                    :reduce="(option) => option.id"
                    multiple
                    :class="v$.message.selectedClasses_ids.$error ? 'is-invalid' : ''"
                    @update:modelValue="ChangeClass($event)"
                  >
                    <template #no-options="{}">
                      {{ $t("common.emptysearchClasse") }}
                    </template>
                  </v-select>
                  <div v-if="v$.message.selectedClasses_ids.$error && classe" class="invalid-feedback">
                    {{ $t("validation.required") }}
                  </div>
                  <v-select
                    v-if="teacher"
                    v-model="message.selectedTeachers_ids"
                    label="item_data"
                    :searchable="true"
                    :options="teachers"
                    :reduce="(option) => option.id"
                    multiple
                    :class="v$.message.selectedTeachers_ids.$error ? 'is-invalid' : ''"
                    @update:modelValue="ChangeTeacher($event)"
                  >
                    <template #no-options="{}">
                      {{ $t("common.emptysearshTeacher") }}
                    </template>
                  </v-select>
                  <div v-if="v$.message.selectedTeachers_ids.$error && teacher" class="invalid-feedback">
                    {{ $t("validation.required") }}
                  </div>
                </div>
              </div>
              <div>
                <br />
              </div>
              <div v-if="existStudent && message.selectedType">
                <div v-if="allowedTypes.includes(message.selectedType)" class="col-md-12 spec-inputs-check div-bottom-select">
                  <div class="notice-info">
                    <p>Veuillez choisir un ou plusieurs destinataires</p>
                  </div>
                  <div class="col-md-12 spec-inputs-check cheked-student">
                    <div class="simple-input-checkbox">
                      <label class="container-checkbox">
                        <input v-model="message.has_module_student" type="checkbox" />
                        <span class="checkmark" />
                      </label>
                      <label class="label check">{{ $t("message.formMsg.sentTo") }}</label>
                    </div>
                    <div class="simple-input-checkbox">
                      <label class="container-checkbox">
                        <input v-model="message.has_module_studentCheked" type="checkbox" />
                        <span class="checkmark" />
                      </label>
                      <label class="label check">{{ $t("message.formMsg.sentToEleve") }}</label>
                    </div>
                  </div>
                </div>
                <div v-if="message.selectedType === 'un_ou_plusieurs_eleves'" class="col-md-12 spec-inputs-check div-bottom-select">
                  <div class="col-md-12 spec-inputs-check cheked-student">
                    <div class="simple-input-checkbox">
                      <label class="container-checkbox">
                        <input v-model="message.has_module_student" type="checkbox" />
                        <span class="checkmark" />
                      </label>
                      <label class="label check">{{ $t("message.formMsg.sentTo") }}</label>
                    </div>
                  </div>
                </div>
                <div v-if="message.selectedType === 'un_ou_plusieurs_eleves_par_ecole'" class="col-md-12 spec-inputs-check div-bottom-select">
                  <div class="col-md-12 spec-inputs-check cheked-student">
                    <div class="simple-input-checkbox">
                      <label class="container-checkbox">
                        <input v-model="message.has_module_studentCheked" type="checkbox" />
                        <span class="checkmark" />
                      </label>
                      <label class="label check">{{ $t("message.formMsg.sentToEleve") }}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="ajout-container__text">
                  <div class="d-flex justify-content-between align-items-center switch-wrapper">
                    <label>{{ $t("message.formMsg.text") }} <sup>*</sup></label>
                  </div>
                  <TinycmeEditorMsg v-model="message.description" :class="{'is-invalid-cme': characterCount > 1000 || (v$.message.description.$error && characterCount === 0)}" @input="handleInput" />
                  <div v-if="v$.message.description.$error && characterCount === 0" class="invalid-feedback">
                    {{ $t("validation.required") }}
                  </div>

                  <span v-if="characterCount > 1000" class="invalid-feedback">La longueur maximale autorisée est de 1000 caractères</span>

                  <label class="indice"
                    >{{ $t("info.sizeText") }}
                    <span v-if="characterCount > 0 && characterCount <= 1000" :class="{'character-limit-exceeded': characterCount === 1000}"
                      >( {{ characterCount }} / 1000 caractères)</span
                    >
                    <span v-if="characterCount > 1000" class="character-limit-exceeded">( 1000 / 1000 caractères)</span>
                  </label>
                </div>
              </div>
              <div>
                <br />
              </div>
              <div class="col-md-5">
                <div class="d-flex flex-column pt-4">
                  <label class="label label-file">
                    {{ $t("message.formMsg.files") }}
                  </label>
                  <div class="input-files__authorized">
                    <span>{{ $t("info.authfile") }}</span>
                    <span>{{ $t("info.maxFile") }}</span>
                  </div>
                  <label class="input-image input-files" for="otherDoc" @change="onFileChange" @click="resetFileUploader">
                    {{ $t("devoir.formDm.infofile") }}
                    <div class="icon-upload">
                      <img src="../../assets/icons/VectorMsg.svg" />
                    </div>
                    <input
                      id="otherDoc"
                      type="file"
                      ref="file"
                      :multiple="true"
                      class="d-none"
                      accept=".pdf, .xls, .xlsx, .xlsm, .docx, .ppt, .pdf, .jpeg, .jpg, .png"
                      tabindex="-1"
                    />
                  </label>
                </div>
              </div>
              <span v-if="valideSize" class="invalid-feedback-size">
                {{ $t("error.errorTailleMsgWithParams") }}
              </span>
              <span v-if="maxFileSize" class="indice errorSizeDoc list">
                <!-- <ul>
                        <li v-for="(item,index) in maxFileSizeTab" :key="index">
                            La taille maximale pour le fichier {{ item }} est de 2Mo.
                        </li>
                </ul>-->
                {{ $t("error.errorTailleMsgWithParams") }}
              </span>
              <span v-if="maxLengthFiles" class="indice errorSizeDoc">{{ $t("error.NbItems") }}</span>

              <div v-if="tabfile.length" class="col-md-12 files-name">
                <ul class="justify-- d-flex">
                  <li v-for="(item, index) in tabfile" :key="index">
                    {{ item.name }}
                    <span class="btn-close-file" @click="deletefile(index)" />
                  </li>
                </ul>
              </div>
              <div class="col-12 button-envoyer text-right">
                <button type="submit" class="btn button btn-primary" :disabled="isSubmitted">
                  <i class="icon-message-dots-circle" />
                  {{ $t("button.send") }}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import Form from "../../core/Form";
import {ref} from "vue";
import useValidate from "@vuelidate/core";
import {required, helpers, requiredIf} from "@vuelidate/validators";
import vSelect from "vue-select";
import MessageService from "../../services/message.service";
import StudentService from "../../services/student.service";
import TeacherService from "../../services/teacher.service";
import HomeWorkService from "../../services/home-work.service";
import TinycmeEditorMsg from "../../components/tinymceMsg.vue";
import _ from "lodash";
const SIZE_IMAGE = 2;
export default {
  name: "AjoutMessage",
  components: {
    TopTemplate,
    "v-select": vSelect,
    TinycmeEditorMsg,
  },
  data() {
    return {
      v$: useValidate(),
      v2$: useValidate(),
      student: false,
      classe: false,
      level: false,
      teacher: false,
      allusers: true,
      levels: [],
      classes: [],
      namedoc: null,
      file: null,
      errorDocSize: false,
      allowedTypes: ["parents_de_eleves_par_niveau_dans_ecole_x", "parents_de_eleves_par_classe_dans_ecole_x"],
      options: [
        {
          name: "Tous le monde",
          id: "tout_le_monde_par_ecole",
        },
        {
          name: "Tous les parents",
          id: "tous_les_parents_de_tous_les_eleves_dans_ecole_x",
        },
        {
          name: "Tous les élèves",
          id: "tous_les_eleves_dans_ecole_x",
        },
        {
          name: "Un ou plusieurs élèves",
          id: "un_ou_plusieurs_eleves",
        },
        {
          name: "Un ou plusieurs parents",
          id: "un_ou_plusieurs_eleves_par_ecole",
        },
        {
          name: "Un ou plusieurs niveaux",
          id: "parents_de_eleves_par_niveau_dans_ecole_x",
        },
        {
          name: "Une ou plusieurs classes",
          id: "parents_de_eleves_par_classe_dans_ecole_x",
        },
        {
          name: "Un ou plusieurs enseignants",
          id: "un_ou_plusieurs_enseignants_par_ecole",
        },
        {
          name: "Tous les enseignants",
          id: "tous_les_enseignants_par_ecole",
        },
      ],
      optionsType: [
        {
          name: "Tous le monde",
          id: "tout_le_monde_par_ecole",
        },
        {
          name: "Tous les parents",
          id: "tous_les_parents_de_tous_les_eleves_dans_ecole_x",
        },
        {
          name: "Un ou plusieurs parents",
          id: "un_ou_plusieurs_eleves_par_ecole",
        },
        {
          name: "Un ou plusieurs niveaux",
          id: "parents_de_eleves_par_niveau_dans_ecole_x",
        },
        {
          name: "Une ou plusieurs classes",
          id: "parents_de_eleves_par_classe_dans_ecole_x",
        },
        {
          name: "Un ou plusieurs enseignants",
          id: "un_ou_plusieurs_enseignants_par_ecole",
        },
        {
          name: "Tous les enseignants",
          id: "tous_les_enseignants_par_ecole",
        },
      ],
      students_id: [],
      Levels_id: [],
      Classes_id: [],
      students: [],
      filesToSend: [],
      teachers_id: [],
      teachers: [],
      errorSave: false,
      existStudent: false,
      isSubmitted: false,
      params: {
        typeEnv: "",
        school_id: null,
        limit: 10,
        action: "registred",
        notice_status: "send",
        q: [],
      },
      checked: false,
      dir: "ltr",
      message: new Form({
        selectedType: null,
        selectedStudent_ids: [],
        selectedLevels_ids: [],
        selectedClasses_ids: [],
        selectedTeachers_ids: [],
        description: null,
        has_module_student: false,
        has_module_studentCheked: false,
        photo: null,
      }),
      files: [],
      filesToSend: [],
      errorSizeDoc: [],
      existStudent: false,
      maxFileSize: false,
      valideSize: false,
      maxLengthFiles: false,
      maxFileSizeTab: [],
      tabfile: [],
      is_created: false,
      loading: false,
      requiredDescriptionLength: 1000,
      characterCount: 0,
      errorMessages: "",
      errorMessageSave: false,
    };
  },
  computed: {
    userModules() {
      return this.$store.state?.auth?.user?.modules;
    },
  },

  validations() {
    return {
      message: {
        selectedType: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },

        selectedStudent_ids: {
          required: requiredIf(function (nestedModel) {
            return this.student;
          }),
        },
        selectedLevels_ids: {
          required: requiredIf(function (nestedModel) {
            return this.level;
          }),
        },
        selectedClasses_ids: {
          required: requiredIf(function (nestedModel) {
            return this.classe;
          }),
        },
        selectedTeachers_ids: {
          required: requiredIf(function (nestedModel) {
            return this.teacher;
          }),
        },
        description: {
          required: helpers.withMessage(this.$t("validation.required"), required),
        },
      },
    };
  },
  /*  validations() {
    if(this.message.selectedType === 'parents_de_eleves_par_classe_dans_ecole_x'){
      return{  message: {selectedClasses_ids: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
      },}};
      }
      if(this.message.selectedType === 'un_ou_plusieurs_eleves_par_ecole'){
      return{  message: {selectedStudent_ids: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
      },}};
      }
      if(this.message.selectedType === 'parents_de_eleves_par_niveau_dans_ecole_x'){
      return{  message: {selectedLevels_ids: {
          required: helpers.withMessage(
            this.$t("validation.required"),
            required
          ),
      },}};
      }
  }, */
  watch: {
    "message.description": function (newDescription) {
      if (newDescription != null) {
        this.updateCharacterCount();
      }
    },
  },
  mounted() {
    this.params.school_id = this.$store.state.auth.user.school_id;
    this.ListStudents();
    this.GetLevels();
    this.GetClasses();
    this.moduleUser();
  },

  methods: {
    updateCharacterCount() {
      const brCount = (this.message.description.match(/<br \/>/g) || []).length;
      const nbspCount = (this.message.description.match(/&nbsp;/g) || []).length;

      let textWithoutTags = this.message.description
        .replace(/<br \/>/g, "")
        .replace(/&nbsp;/g, "")
        .replace(/\s/g, "");

      // Compter la longueur des textes ancrés dans les liens
      const anchorTags = this.message.description.match(/<a href="[^"]+">([^<]+)<\/a>/g) || [];
      let anchorTextLength = 0;
      anchorTags.forEach((tag) => {
        const match = tag.match(/<a href="[^"]+">([^<]+)<\/a>/);
        if (match && match[1]) {
          anchorTextLength += match[1].length;
        }
      });

      // Retirer la longueur des balises <a> complètes pour ne compter que les textes ancrés
      textWithoutTags = textWithoutTags.replace(/<ahref="[^"]+">([^<]+)<\/a>/g, "");
      const textLength = textWithoutTags.length + anchorTextLength; // Ajouter la longueur des textes ancrés

      this.characterCount = textLength + brCount + nbspCount;
    },
    handleInput() {
      this.updateCharacterCount();
    },
    validateFileSize(event) {
      this.valideSize = false;
      const maxSizeInBytes = 2 * 1024 * 1024;
      const file = event.target.files[0];

      if (file && file.size > maxSizeInBytes) {
        event.target.value = "";
        this.valideSize = true;
      }
    },
    checkFilesSize: _.throttle(function (file) {
      if (!file) {
        this.errorDocSize = false;
      }
      this.errorDocSize = file.size / 1024 / 1024 > SIZE_IMAGE;
    }, 300),
    resetFileUploader() {
      this.$refs.file.value = "";
    },
    checkIfElementNameIsEleves() {
      return this.userModules.some((element) => element.name === this.$t("modules.student"));
    },
    moduleUser() {
      this.existStudent = this.checkIfElementNameIsEleves();
    },
    onFileChange(event) {
      this.maxLengthFiles = false;
      const files = Object.entries(event.target.files).map(([key, value]) => value);
      const newFiles = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        if (!this.tabfile.includes(file)) {
          newFiles.push(file);
        }
      }

      if (this.tabfile.length + newFiles.length <= 5) {
        this.tabfile = this.tabfile.concat(newFiles);
      } else {
        this.maxLengthFiles = true;
      }

      this.validateFiles();
    },
    validateFiles() {
      for (let i = 0; i < this.tabfile.length; i++) {
        const file = this.tabfile[i];
        if (file.size > 2 * 1024 * 1024) {
          this.tabfile.splice(i, 1);
          this.maxFileSize = true;
          i--;
        }
      }
    },
    deletefile(index) {
      this.tabfile.splice(index, 1);
    },
    resetFileUploader() {
      this.$refs.file.value = "";
    },
    checkFilesNumber(files) {
      this.maxLengthFiles = false;
      if (files.length > 5) {
        this.maxLengthFiles = true;
      }
    },
    checkFileSize: function (file) {
      if (!file) return false;
      let size = file.size;
      this.errorSizeDoc.push(size);
      if (this.errorSizeDoc.some((item) => item / 1024 / 1024 > MAX_SIZE)) {
        this.maxFileSize = true;
      } else {
        this.maxFileSize = false;
      }
    },
    changeLanguage() {
      if (this.checked === true) {
        this.dir = "rtl";
      } else {
        this.dir = "ltr";
      }
    },
    GetLevels() {
      HomeWorkService.getFilter({
        params: {},
      }).then(
        (response) => {
          this.levels = response.data.types;
        },
        (error) => {}
      );
    },
    GetClasses() {
      HomeWorkService.getFilter({
        params: {},
      }).then(
        (response) => {
          this.classes = _.orderBy(response.data.classes, "name");
        },
        (error) => {}
      );
    },

    ChangeStudent(e) {
      if (e != null) {
        this.students_id = [];
        this.Levels_id = [];
        this.Classes_id = [];
        this.teachers_id = [];
        this.students_id.push(e);
      } else {
        this.params.class_school_id = [];
      }
    },
    ChangeTeacher(e) {
      if (e != null) {
        this.teachers_id = [];
        this.students_id = [];
        this.Levels_id = [];
        this.Classes_id = [];
        this.teachers_id.push(e);
      } else {
        this.params.class_school_id = [];
      }
    },
    ChangeLevel(e) {
      if (e != null) {
        this.students_id = [];
        this.Levels_id = [];
        this.Classes_id = [];
        this.teachers_id = [];
        this.Levels_id.push(e);
      } else {
        this.params.Levels_id = [];
      }
    },
    ChangeClass(e) {
      if (e != null) {
        this.students_id = [];
        this.Levels_id = [];
        this.Classes_id = [];
        this.teachers_id = [];
        this.Classes_id.push(e);
      } else {
        this.params.Classes_id = [];
      }
    },
    ChangeType(e) {
      this.errorSave = false;
      this.params.typeEnv = e;
      this.message.selectedStudent_ids = [];
      this.message.selectedLevels_ids = [];
      this.message.selectedClasses_ids = [];
      this.message.selectedTeachers_ids = [];
      this.v$.message.selectedStudent_ids.$reset();
      this.v$.message.selectedLevels_ids.$reset();
      this.v$.message.selectedClasses_ids.$reset();
      this.v$.message.selectedTeachers_ids.$reset();
      this.errorSizeDoc = [];
      this.filesToSend = [];
      this.tabfile = [];
      this.maxFileSize = false;
      if (e == "tous_les_parents_de_tous_les_eleves_dans_ecole_x") {
        this.level = false;
        this.student = false;
        this.classe = false;
        this.teacher = false;
        this.allusers = false;
        let elem = this.$refs.simpleselect;
        elem.classList.remove("col-md-6");
        elem.classList.add("col-md-12");
      }
      if (e == "tous_les_eleves_dans_ecole_x") {
        this.level = false;
        this.student = false;
        this.classe = false;
        this.teacher = false;
        this.allusers = false;
        this.params.q = "";
        let elem = this.$refs.simpleselect;
        elem.classList.remove("col-md-6");
        elem.classList.add("col-md-12");
      }
      if (e == "parents_de_eleves_par_niveau_dans_ecole_x") {
        this.level = true;
        this.student = false;
        this.message.has_module_student = true;
        this.message.has_module_studentCheked = false;
        this.classe = false;
        this.teacher = false;
        this.allusers = false;
        let elem = this.$refs.simpleselect;
        elem.classList.remove("col-md-12");
        elem.classList.add("col-md-6");
      }
      if (e == "parents_de_eleves_par_classe_dans_ecole_x") {
        this.level = false;
        this.student = false;
        this.message.has_module_student = true;
        this.message.has_module_studentCheked = false;
        this.classe = true;
        this.teacher = false;
        this.allusers = false;
        let elem = this.$refs.simpleselect;
        elem.classList.remove("col-md-12");
        elem.classList.add("col-md-6");
      }
      if (e == "un_ou_plusieurs_eleves_par_ecole") {
        this.level = false;
        this.student = true;
        this.teacher = false;
        this.message.has_module_student = false;
        this.message.has_module_studentCheked = true;
        this.classe = false;
        this.allusers = false;
        this.params.q = "";
        this.params.action = "registred";
        let elem = this.$refs.simpleselect;
        elem.classList.remove("col-md-12");
        elem.classList.add("col-md-6");
        this.ListStudents();
      }
      if (e == "un_ou_plusieurs_eleves") {
        this.level = false;
        this.student = true;
        this.teacher = false;
        this.message.has_module_student = true;
        this.message.has_module_studentCheked = false;
        this.classe = false;
        this.allusers = false;
        this.params.q = "";
        this.params.action = "registred_student";
        let elem = this.$refs.simpleselect;
        elem.classList.remove("col-md-12");
        elem.classList.add("col-md-6");
        this.ListStudents();
      }
      if (e == "un_ou_plusieurs_enseignants_par_ecole") {
        this.level = false;
        this.student = false;
        this.teacher = true;
        this.classe = false;
        this.allusers = false;
        this.params.q = "";
        this.params.action = "registred";
        let elem = this.$refs.simpleselect;
        elem.classList.remove("col-md-12");
        elem.classList.add("col-md-6");
        this.ListTeachers();
      }
      if (e == "tous_les_enseignants_par_ecole") {
        this.level = false;
        this.student = false;
        this.classe = false;
        this.teacher = false;
        this.allusers = false;
        this.params.q = "";
        let elem = this.$refs.simpleselect;
        elem.classList.remove("col-md-6");
        elem.classList.add("col-md-12");
      }
      if (e == "tout_le_monde_par_ecole") {
        this.level = false;
        this.student = false;
        this.classe = false;
        this.teacher = false;
        this.allusers = false;
        this.params.q = "";
        let elem = this.$refs.simpleselect;
        elem.classList.remove("col-md-6");
        elem.classList.add("col-md-12");
      }
    },
    createNames(files) {
      this.tabfile = [];
      for (let index = 0; index < files.length; index++) {
        this.tabfile.push({name: files[index].name});
      }
    },

    ListTeachers() {
      this.loading = true;
      TeacherService.getAll({
        params: {
          school_id: this.params.school_id,
          type: this.params.typeEnv,
          action: this.params.action,
          q: this.params.q,
        },
      })
        .then((response) => {
          this.teachers = response.data.data;
          this.teachers.map(function (item) {
            return (item.item_data = item.first_name + " " + item.last_name);
          });
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmitCreateMessage() {
      this.v$.$validate();
      this.v$.$validate();
      if (this.errorDocSize) {
        this.scrollToTop();
      }
      if (!this.errorDocSize && !this.v$.$error && this.characterCount <= 1000) {
        let teachers_list = this.message.selectedType === "un_ou_plusieurs_enseignants_par_ecole" ? this.teachers_id : null;
        if (teachers_list === null) {
          this.teachers_id = teachers_list;
        } else {
          this.teachers_id = teachers_list[0];
        }
        /*  const data = {
          title: this.message.selectedType,
          type: this.message.selectedType,
          message: this.message.description,
          school_id: this.params.school_id,
          class_type_id: this.message.selectedLevels_ids,
          class_school_id: this.message.selectedClasses_ids,
          students_id: this.message.selectedStudent_ids,
          photo: this.message.photo ? this.message.photo : "",
          is_arabic: this.dir === "rtl" ? 1 : "",
          teachers_id: this.teachers_id,
        }; */
        let formData = new FormData();
        formData.append("_method", "POST");
        formData.append("title", this.message.selectedType);
        formData.append("type", this.message.selectedType);
        formData.append("message", this.message.description);
        formData.append("school_id", this.params.school_id);

        if (this.message.has_module_studentCheked && this.message.has_module_student) {
          formData.append("send_to", null);
        } else {
          if (this.message.has_module_student) {
            formData.append("send_to", 2);
          }
          if (this.message.has_module_studentCheked) {
            formData.append("send_to", 1);
          }
        }

        formData.append("class_type_id", JSON.stringify(this.message.selectedLevels_ids));
        formData.append("class_school_id", JSON.stringify(this.message.selectedClasses_ids));
        formData.append("students_id", JSON.stringify(this.message.selectedStudent_ids));
        formData.append("teachers_id", JSON.stringify(this.message.selectedTeachers_ids));
        if (this.existStudent) {
          formData.append("has_module_student", this.existStudent);
        } else {
          formData.append("send_to", null);
        }

        formData.append("is_arabic", this.dir === "rtl" ? 1 : "");
        if (this.message.selectedType === "tous_les_eleves_dans_ecole_x") {
          formData.append("has_module_student", true);
        }

        for (var i = 0; i < this.tabfile.length; i++) {
          let file = this.tabfile[i];
          formData.append("files[" + i + "]", file);
        }

        const Swal = require("sweetalert2");
        const swalWithBootstrapButtons = Swal.mixin({
          customClass: {
            confirmButton: "btn btn-confirm  btn-primary",
            cancelButton: "btn  btn-cancel  btn-outline-primary",
          },
          buttonsStyling: false,
          showCloseButton: true,
        });

        swalWithBootstrapButtons
          .fire({
            title: this.$t("common.confirmSendMessage"),
            icon: "warning",
            customClass: {
              confirmButton: "btn btn-confirm  btn-primary",
              cancelButton: "btn  btn-cancel  btn-outline-primary",
            },
            showCloseButton: true,
            showCancelButton: true,
            confirmButtonText: this.$t("common.deletIT"),
            cancelButtonText: this.$t("common.noCancel"),
            reverseButtons: true,
          })
          .then((result) => {
            if (result.isConfirmed) {
              this.isSubmitted = true;
              // swalWithBootstrapButtons.fire(
              //     this.$t("common.messageSend"),
              //     "",
              //     "success"
              // );

              MessageService.create(formData)
                .then(() => {
                  this.is_created = true;
                  this.errorSave = false;
                  // this.scrollToTop();
                  this.$store.dispatch("setSended", true);
                  this.$router.push({
                    name: "Message",
                    params: {notice_status: "send"},
                  });
                })
                .then(() => {
                  this.$nextTick(() => {
                    this.message.reset();
                    this.namedoc = null;
                    this.v$.$reset();
                    this.dir = "ltr";
                  });
                })

                .catch((error) => {
                  this.is_created = false;
                  if (error.response.status === 204) {
                    this.errorSave = error.response.data.error;
                  }
                  if (error.response.status === 409) {
                    this.errorMessageSave = true;
                    this.errorMessages = error.response.data.error;
                  }
                  this.scrollToTop();
                })
                .finally(() => {
                  this.isSubmitted = false;
                  this.loading = false;
                });
            }
          });
      } else {
        this.loading = false;
        this.is_created = false;
        this.scrollToTop();
      }
    },
    ListStudents() {
      this.loading = true;
      StudentService.getAll({
        params: {
          school_id: this.params.school_id,
          type: this.params.typeEnv,
          q: this.params.q,
          action: this.params.action,
        },
      }).then(
        (response) => {
          this.students = response.data.data;
          this.students.map(function (item) {
            return (item.item_data = item.first_name + " " + item.last_name);
          });
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    route() {
      this.$router.push({
        name: "Message",
        params: {notice_status: "send"},
      });
    },
    ListSearchStudents() {
      this.loading = true;
      StudentService.getAll({
        params: {
          school_id: this.params.school_id,
          type: this.params.typeEnv,
          q: this.params.q,
          action: this.params.action,
        },
      }).then(
        (response) => {
          this.students = this.students.concat(response.data.data);

          this.students = this.students.reduce((unique, o) => {
            if (!unique.some((obj) => obj.id === o.id)) {
              unique.push(o);
            }
            return unique;
          }, []);
          // this.students= _.orderBy(response.data.data, "first_name", "asc");
          this.students.map(function (item) {
            return (item.item_data = item.first_name + " " + item.last_name);
          });
          this.loading = false;
        },
        (error) => {
          this.loading = false;
        }
      );
    },
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },

    // searshStudent: _.throttle(function(value) {
    //   this.students = [];

    //   let params = {
    //     params: {
    //       q: value,
    //       hasfilter : true
    //     }
    //   };

    //   if (value.length < 3) return false;
    //     StudentService.getAll({
    //     params: params,
    //   }).then(
    //     (response) => {
    //       this.students =  response.data.data.reverse().map(function(item) {
    //       let name = item.first_name + " " + item.last_name;
    //       item.label = name;
    //       return item;
    //     });
    //     },
    //   );
    // }, 300),
    searshStudent: _.debounce(function (e) {
      if (e.target.value.length > 1) {
        this.params.q = e.target.value;
        //this.params.q=e.target.value;
        this.params.hasfilter = true;
        this.ListSearchStudents();
      }
    }, 200),
  },
};
</script>
<style>
.div-bottom-select {
  border-left: 1px solid rgba(224, 231, 237, 1);
  padding-left: 15px;
}
.cheked-student {
  display: flex;
}
.cheked-student .simple-input-checkbox {
  padding-right: 20px;
}
.notice-info p {
  font-size: 10px;
  font-style: italic;
  margin-bottom: 10px;
}
.cheked-student .simple-input-checkbox .label.check {
  color: #333;
  font-size: 12px;
}
.message-add .errorSizeDoc {
  left: 0;
  position: relative;
  font-size: 10px;
  color: #dc3545;
}
.invalid-border {
  border-color: var(--bs-form-invalid-color);
}
.invalid-feedback-size {
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}

.message-add .indice {
  margin-left: 0;
  font-style: normal;
}
.message-add .indice__text {
  margin-left: 0;
  font-size: 11px !important;
  color: #36b7b9 !important;
}
</style>
